import CheckboxField from './checkbox'

export default CheckboxField


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/components/checkbox/index.js
// module id = null
// module chunks = 